const getCompanyLogoUrl = (companyUrl?: string) =>
  companyUrl ? `/api/logo/${companyUrl}?format=png&retina=true` : undefined;

export default getCompanyLogoUrl;
